@if (isOpen()) {
  <div
    class="fixed inset-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-dropdown p-4 animate-fade-in"
    (click)="onBackdropClick()"
    (keydown.escape)="onCancel()"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="modalTitle"
  >
    <div
      class="bg-white rounded-xl w-full max-w-modal-sm flex flex-col shadow-lg animate-slide-up"
      role="document"
    >
      <!-- Modal Header -->
      <div
        class="flex justify-between items-center p-6 border-b border-gray-300"
      >
        <h3 class="text-xl font-bold text-brand-tertiary m-0">
          {{ modalTitle }}
        </h3>
        @if (state() !== ExportModalState.DOWNLOADING) {
          <button
            class="w-8 h-8 min-w-btn-icon min-h-btn-icon border-none bg-transparent cursor-pointer p-0 flex items-center justify-center transition-opacity duration-200 hover:opacity-70 focus-visible:outline-2 focus-visible:outline-brand-tertiary focus-visible:outline-offset-2 focus-visible:rounded"
            (click)="onCancel()"
            aria-label="Cerrar modal"
            type="button"
          >
            <span class="icon-equis w-6 h-6 block" aria-hidden="true"></span>
          </button>
        }
      </div>

      <!-- Modal Body -->
      <div
        class="p-8 px-6 flex flex-col items-center justify-center min-h-modal-content"
      >
        <!-- Confirmation State -->
        @if (state() === ExportModalState.CONFIRMATION) {
          <div class="flex flex-col items-center gap-6 text-center">
            <span
              class="icon-download-modal w-16 h-16 block"
              aria-hidden="true"
            ></span>
            <p class="text-base leading-6 text-gray-500 m-0 max-w-modal-text">
              {{ modalMessage }}
            </p>
          </div>
        }

        <!-- Downloading State -->
        @if (state() === ExportModalState.DOWNLOADING) {
          <div class="flex flex-col items-center gap-6">
            <div
              class="spinner w-12 h-12 relative"
              role="status"
              aria-live="polite"
            >
              <div
                class="spinner-circle w-full h-full border-3 border-gray-300 border-t-brand-tertiary rounded-full"
              ></div>
            </div>
            <p class="text-base text-gray-500 m-0">{{ modalMessage }}</p>
          </div>
        }
      </div>

      <!-- Modal Footer (only for confirmation state) -->
      @if (showButtons) {
        <div class="flex justify-between gap-4 p-6 border-t border-gray-300">
          <app-button
            label="Cancelar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="onCancel()"
          >
          </app-button>
          <app-button
            label="Confirmar"
            [type]="ButtonTypeEnum.PRIMARY"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="onConfirm()"
          >
          </app-button>
        </div>
      }
    </div>
  </div>
}
